import React from 'react';

const RowEditor = ({ rowsData, rowCount, onRowChange }) => (
  <div className="row-editor">
    <h3>Předvyplnění položek</h3>
    <p>Zadejte předvyplněné položky, které se zobrazí na všech účtenkách:</p>
    <table className="row-editor-table">
      <thead>
      <tr>
        <th>#</th>
        <th>Popis</th>
        <th>DPH %</th>
        <th>Celkem</th>
      </tr>
      </thead>
      <tbody>
      {rowsData.slice(0, rowCount).map((row, index) => (
        <tr key={index}>
          <td>{index + 1}.</td>
          <td>
            <input
              type="text"
              value={row.description}
              onChange={(event) => onRowChange(index, 'description', event.target.value)}
              placeholder="Popis zboží"
              className="row-editor-input"
            />
          </td>
          <td>
            <input
              type="text"
              value={row.vatRate}
              onChange={(event) => onRowChange(index, 'vatRate', event.target.value)}
              placeholder="21"
              className="row-editor-input small-input"
            />
          </td>
          <td>
            <input
              type="text"
              value={row.totalPrice}
              onChange={(event) => onRowChange(index, 'totalPrice', event.target.value)}
              placeholder="0"
              className="row-editor-input small-input"
            />
          </td>
        </tr>
      ))}
      </tbody>
    </table>
  </div>
);

export default RowEditor;
